<script setup>
// 底部组件
const props = defineProps({
    common: {
        type: Object,
        required: false,
        default: () => {
            webname: ''
        },
    },
    friend: {
        required: false,
        default: () => [],
    },
})


const valueTransmission = ref([])
const isMobile = ref(window.innerWidth < 768)


// 提取警号
const policeNumber = (police) => {
    const match = police ? police.match(/\d+/) : null
    return match ? match[0] : ""
}

</script>

<template>

    <div class="Heziyun-footer" id="footer">
        <!-- 底部页脚（黑色） -->
        <div class="Heziyun-bottomFooter">
            <div class="Heziyun-defaultWidth">

                <div class="Heziyun-top">
                    <div class="Heziyun-connectNavigation">
                        <div class="Heziyun-itemLink">
                            <span>{{ common?.webname }}{{ $t('index.footer1') }}</span>
                            <a href="/company.html">{{ $t('index.footer2') }}</a>
                            <a href="/company.html">{{ $t('index.footer3') }}</a>
                        </div>

                        <div class="Heziyun-itemLink">
                            <span>{{ $t('index.footer4') }}</span>
                            <a href="/gamePlan.html">{{ $t('index.solution4') }}</a>
                            <a href="/finance.html">{{ $t('index.solution6') }}</a>
                            <a href="/ecommerce.html">{{ $t('index.solution7') }}</a>
                            <a href="/website.html">{{ $t('index.solution3_3') }}</a>
                            <a href="/mobile.html">{{ $t('index.solution5') }}</a>
                        </div>

                        <div class="Heziyun-itemLink">
                            <span>{{ $t('index.footer5') }}</span>
                            <a href="/knowledgebase">{{ $t('index.footer6') }}</a>
                            <a href="/knowledgebase">{{ $t('index.footer7') }}</a>
                            <a href="/knowledgebase">{{ $t('index.footer8') }}</a>
                            <a href="/knowledgebase">{{ $t('index.footer9') }}</a>
                            <a href="/submitticket">{{ $t('index.footer10') }}</a>
                        </div>
                        <div class="Heziyun-itemLink">
                            <span>{{ $t('index.footer11') }}</span>
                            <a href="/agent.html">{{ $t('index.footer12') }}</a>
                            <a href="/cpsExtension.html">{{ $t('index.footer13') }}</a>
                            <a href="/new_Smell.html?Class=1">{{ $t('index.footer14') }}</a>
                            <a href="/company.html">{{ $t('index.footer15') }}</a>
                            <a href="/cart">{{ $t('index.footer16') }}</a>
                        </div>
                        <div class="Heziyun-itemLink">
                            <span>{{ $t('index.footer17') }}</span>
                            <a href="/clientarea">{{ $t('index.footer18') }}</a>
                            <a href="/security">{{ $t('index.footer19') }}</a>
                            <a href="/downloads">{{ $t('index.footer20') }}</a>
                            <a href="/transaction">{{ $t('index.footer21') }}</a>
                            <a href="/details">{{ $t('index.footer22') }}</a>
                        </div>
                    </div>
                    <div class="Heziyun-bottomLogo">
                        <div class="Heziyun-logoCompany">
                            <img :src="common?.logo1" alt="">
                            <div class="Heziyun-company">
                                <span>{{ common?.groupname }}</span>
                                <span>
                                    {{ $t('index.footer23') }}：
                                    <a :href="item.url" target="_blank" v-for="item in friend" :key="item.id">《{{ item.title }}》</a>
                                </span>

                            </div>
                        </div>
                        <div class="Heziyun-hotline">
                            <div class="Heziyun-small">
                                <span>{{ $t('index.footer24') }}：</span>
                                <p>{{ common?.phone }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="Heziyun-bottom">
                    <div class="Heziyun-keepOnRecord">
                        <a href="https://beian.miit.gov.cn/" target="_blank" v-if="common?.icp">
                            <img src="@/static/img/footer/keepOnRecord2.webp" alt="">
                            {{ common?.icp }}
                        </a>
                        <a v-if="common?.police"
                            :href="`https://www.beian.gov.cn/portal/registererSystemInfo?recordcode=${policeNumber(common?.police)}`"
                            target="_blank">
                            <img src="@/static/img/footer/keepOnRecord.webp" alt="">
                            {{ common?.police }}
                        </a>
                        <p v-if="common?.telecommunication">
                            <img src="@/static/img/footer/keepOnRecord.webp" alt="">{{ common?.telecommunication
                            }}
                        </p>
                    </div>
                    <div class="Heziyun-copyright">
                        <p v-html="common?.copyright"></p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style lang="less">
.Heziyun-footer {

    @keyframes enters {
        0% {
            opacity: 0;
            transform: translateX(100%);
            -webkit-transform: translateX(100%);
            -moz-transform: translateX(100%);
            -ms-transform: translateX(100%);
            -o-transform: translateX(100%);
        }

        100% {
            opacity: 1;
            transform: translateX(0);
            -webkit-transform: translateX(0);
            -moz-transform: translateX(0);
            -ms-transform: translateX(0);
            -o-transform: translateX(0);
        }
    }

    // 底部页脚（黑色）
    .Heziyun-bottomFooter {
        background: #1A1A1A;
        padding: 3rem 0;

        .Heziyun-defaultWidth {
            .Heziyun-top {
                .Heziyun-connectNavigation {
                    display: flex;
                    justify-content: space-between;

                    .Heziyun-itemLink {
                        display: flex;
                        flex-direction: column;
                        width: 13rem;

                        span {
                            color: #fff;
                            font-size: 1.1rem;
                            margin-bottom: 1rem;
                        }

                        a {
                            color: #9CA3AF;
                            font-size: 0.75rem;
                            padding: 0.5rem 0.5rem 0.5rem 0;
                            border-bottom: 1px solid transparent;
                            transition: all 0.3s ease;
                            -webkit-transition: all 0.3s ease;
                            -moz-transition: all 0.3s ease;
                            -ms-transition: all 0.3s ease;
                            -o-transition: all 0.3s ease;

                            &:hover {
                                color: #fff;
                                padding: 0.5rem 0.5rem 0.5rem 1rem;
                                border-bottom: 1px solid #ffffff21;
                                transition: all 0.3s ease;
                                -webkit-transition: all 0.3s ease;
                                -moz-transition: all 0.3s ease;
                                -ms-transition: all 0.3s ease;
                                -o-transition: all 0.3s ease;
                                background-color: #ffffff21;
                            }
                        }
                    }
                }

                .Heziyun-bottomLogo {
                    border-top: 1px solid #1f2937;
                    border-bottom: 1px solid #1F2937;
                    padding: 1rem 0;
                    margin: 2rem 0;
                    display: flex;
                    justify-content: space-between;

                    .Heziyun-logoCompany {
                        display: flex;
                        flex-direction: column;
                        gap: 1vw;

                        img {
                            width: 15rem;
                            height: 5rem;
                            object-fit: contain;
                        }

                        .Heziyun-company {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            gap: 0.5rem;

                            span {
                                color: #D1D5DB;
                                font-size: 0.8rem;

                                a {
                                    color: #D1D5DB;

                                    &:hover {
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }

                    .Heziyun-hotline {
                        display: flex;
                        align-items: center;
                        gap: 1.5rem;

                        .Heziyun-small {
                            display: flex;
                            flex-direction: column;
                            gap: 0.3rem;

                            span {
                                color: #D1D5DB;
                                font-size: 0.8rem;
                            }

                            p {
                                color: #0066CC;
                                font-weight: bold;
                                font-size: 1.5rem;
                                filter: drop-shadow(1px 2px 4px #000);
                            }
                        }

                    }
                }
            }

            .Heziyun-bottom {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;

                .Heziyun-keepOnRecord {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 1rem;

                    a {
                        text-align: center;
                        color: #6B7280;
                        font-size: 0.8rem;
                        display: flex;
                        align-items: center;
                        gap: 0.2rem;

                        img {
                            width: 1rem;
                            height: 1rem;
                        }

                        &:hover {
                            color: #fff;
                        }
                    }

                    p {
                        text-align: center;
                        color: #6B7280;
                        font-size: 0.8rem;
                        display: flex;
                        align-items: center;
                        gap: 0.2rem;

                        img {
                            width: 1rem;
                            height: 1rem;
                        }
                    }
                }

                .Heziyun-copyright {
                    p {
                        text-align: center;
                        color: #6B7280;
                        font-size: 0.8rem;
                    }
                }
            }
        }
    }

    // 底部页脚（黑色）
    @media (max-width: 768px) {
        .Heziyun-bottomFooter {
            padding: 5vw 0;

            .Heziyun-defaultWidth {
                .Heziyun-top {
                    .Heziyun-connectNavigation {
                        display: none;
                    }

                    .Heziyun-bottomLogo {
                        padding: 0;
                        margin: 0;
                        flex-direction: column;
                        align-items: center;
                        border-top: 0px solid;
                        border-bottom: 0px solid;
                        gap: 3vw;

                        .Heziyun-logoCompany {
                            display: flex;

                            img {
                                width: 55vw;
                                height: 20vw;
                            }

                            .Heziyun-company {
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                gap: 2vw;

                                span {
                                    font-size: 3.5vw;
                                    text-align: center;
                                }
                            }
                        }

                        .Heziyun-hotline {
                            gap: 7vw;

                            .Heziyun-small {
                                display: flex;
                                flex-direction: column;
                                gap: 1vw;

                                span {
                                    color: #D1D5DB;
                                    font-size: 3.3vw;
                                }

                                p {
                                    color: #0066CC;
                                    font-weight: bold;
                                    font-size: 4vw;
                                }
                            }
                        }
                    }
                }

                .Heziyun-bottom {
                    gap: 1vw;
                    margin-top: 5vw;

                    .Heziyun-keepOnRecord {
                        flex-direction: column;
                        gap: 2vw;

                        a {
                            font-size: 3.5vw;
                            gap: 1vw;

                            img {
                                width: 3vw;
                                height: 3vw;
                            }
                        }

                        p {
                            font-size: 3.5vw;
                            line-height: 6vw;
                            gap: 0.5vw;

                            img {
                                width: 3vw;
                                height: 3vw;
                            }
                        }
                    }

                    .Heziyun-copyright {
                        p {
                            font-size: 3.5vw;
                            line-height: 6vw;
                        }
                    }
                }
            }
        }
    }

   
}
</style>
